import { render, staticRenderFns } from "./SelectCollectTargetModal.vue?vue&type=template&id=5f43cbd4&scoped=true"
import script from "./SelectCollectTargetModal.vue?vue&type=script&lang=js"
export * from "./SelectCollectTargetModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCollectTargetModal.vue?vue&type=style&index=0&id=5f43cbd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43cbd4",
  null
  
)

export default component.exports